import header from "./header";
import Helmet from "react-helmet";
import {
  listView,
  photoView,
  getTitleBase,
  getCorrectOffSalesRegion,
} from "../shared/util";
import React, { Component } from "react";
import request from "superagent";
import ResultsHeader from "./results-header";
import ResultsView from "../homepage/featured/results-view";
import Pagination from "../search/pagination";
import {
  getAgentIds,
  getEntityLabel,
  getSortField,
  modifyFilter,
  parseBannerFilter,
  parsePage,
  singularListingType,
} from "../shared/util";

import "./my-listings.scss";
class MyListings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        agentId: getAgentIds(props.entity),
        bannerFilter: parseBannerFilter(props),
        resultsPerPage: 12,
        activePage: parsePage(props),
        sortField: getSortField(props),
        listingType: singularListingType(props.params.listingType),
        source: "sir",
      },
      rentalsCount: 0,
      salesCount: 0,
      results: [],
    };
  }

  componentDidMount() {
    this.getListings();
    this.getCounts();
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.abort();
    }
    if (this.countRequest) {
      this.countRequest.abort();
    }
  }

  changeFilter = (name, value) => {
    const filter = modifyFilter(this.state.filter, name, value);
    this.setState({ filter: filter }, () => {
      this.getListings();
    });
  };

  getListings = () => {
    this.request = request
      .post("/api/listings")
      .set("Content-Type", "application/json")
      .send(this.state.filter)
      .end((error, response) => {
        if (response && response.body) {
          this.setState(response.body);
        } else {
          console.error(error);
        }
      });
  };

  getCounts = () => {
    this.countRequest = request
      .post("/api/listings/counts")
      .set("Content-Type", "application/json")
      .send({ agentId: getAgentIds(this.props.entity) }) // check if agentIds being passed as filter
      .end((error, response) => {
        if (response && response.body) {
          this.setState(response.body, () => {
            this.saleRentalToggle();
          });
        } else {
          console.error(error);
        }
      });
  };

  saleRentalToggle = () => {
    if (this.state.salesCount === 0 && this.state.rentalsCount > 0) {
      this.props.router.replace("/listings/rentals");
      this.changeFilter("listingType", "rental");
    }
  };

  render() {
    const showOptions =
      this.state.results.length > this.props.defaultOptions.listViewLimit
        ? photoView
        : listView;
    const title = `Exclusive Listings - ${getTitleBase(this.props.entity)}`;
    return (
      <div className="my-listings featured-listings">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`View exclusive luxury real estate and homes for ${
              this.props.params.listingType === "sales" ? "sale" : "rent"
            } from ${this.props.entity.brand} ${getEntityLabel(
              this.props.entity
            ).toLowerCase()} ${
              this.props.entity.displayName
            } in ${getCorrectOffSalesRegion(
              this.props.entity
            )}. Get details, photos, videos & more.`}
          />
        </Helmet>
        <div className="web-container">
          <div className="page-header">
            <h3>{header(this.props.entity.siteOptions)}</h3>
            <div className="header-separator"></div>
          </div>
          <ResultsHeader
            changeFilter={this.changeFilter}
            location={this.props.location}
            resultState={this.state}
          />
          <ResultsView listings={this.state.results} options={showOptions} />
          <div className="results-footer container">
            <Pagination
              count={this.state.resultCount}
              pageSize={this.state.filter.resultsPerPage}
              activePage={this.state.filter.activePage}
              location={this.props.location}
              changeFilter={this.changeFilter}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MyListings;



// WEBPACK FOOTER //
// ./src/components/my-listings/my-listings.js